import { StyledAboutMe } from "./StyledAboutMe";
import { T } from "../T";

const skills = [
  "TypeScript",
  "JavaScript",
  "React",
  "Next.js",
  "Angular",
  "WordPress / Gutenberg",
  "Tailwind CSS",
  "CSS / Sass",
  "Redux / NgRx",
  "GraphQL",
  "Node.js",
  "Jest",
  "React Testing Library",
  "Git",
  "HTML",
  "PHP",
  "Figma",
  "Adobe Photoshop",
  "Adobe Illustrator",
];
export const AboutMe = () => {
  return (
    <StyledAboutMe id="aboutMe">
      <div className="parallax">
        <div className="content">
          <h2>
            <T>aboutMe</T>
          </h2>
          <ul className="bio">
            <li>
              💼 <T>bio1</T>
            </li>
            <li>
              💻 <T>bio2</T>
            </li>
            <li>
              💻 <T>bio3</T>
            </li>
            <li>
              🎓 <T>bio4</T>
            </li>
          </ul>
          <div className="skills">
            <h3>
              <T>skills</T>
            </h3>
            <ul>
              {skills.map((e, i) => (
                <li key={i}>{e}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </StyledAboutMe>
  );
};
